'use strict';

angular
	.module('theme')
	.service('GiftcardService', function ($rootScope, $q, $http, $cookies) {
		var service = this;

		this.checkout = function (cart) {
			return $http({
				url: '/backapi/ShopCartGiftCheckout',
				method: 'POST',
				data: {
					customerID: cart.customerId,
					number: cart.amount,
					priceEach: cart.value,
					deliveryMail: false,
				},
				cache: false,
			}).then(function (response) {
				return response.data;
			});
		};

		this.getSummary = function (cart) {
			return service.checkout(cart).then(function () {
				return $http({
					url: '/backapi/ShopCartSummary',
					method: 'POST',
					data: {
						customerID: cart.customerId,
						useLoyaltyPoints: false
					},
					cache: false,
				}).then(function (response) {
					return response.data;
				});
			});
		};

		this.completeOrder = function (cart) {
			var data = {
				customerID: cart.customerId,
				useLoyaltyPoints: false,
				payDirect: true,
				rememberEmail: cart.checkoutType === 'customer'
			};

			return $http({
				url: '/backapi/ShopCartOrder',
				method: 'POST',
				data: data,
				cache: false,
			}).then(function (response) {
				service._removeCookie();

				return response.data;
			});
		};

		this.order = function (cart) {
			var data = {
				customerID: cart.customerId,
				useLoyaltyPoints: false,
				payDirect: false,
				rememberEmail: true
			};

			return $http({
				url: '/backapi/ShopCartOrder',
				method: 'POST',
				data: data,
				cache: false,
			}).then(function (response) {
				service._removeCookie();

				return response.data;
			});
		};

		this.getCart = function () {
			return service._getCookie();
		};

		this.setCart = function (cart) {
			$cookies.remove('cart-token', {
				path: '/',
			});

			return service._setCookie(cart);
		};

		this.removeCart = function () {
			service._removeCookie();
		};

		this._removeCookie = function () {
			$cookies.remove('giftcard-cart', {
				path: '/',
			});
		};

		this._getCookie = function () {
			return $cookies.getObject('giftcard-cart');
		};

		this._setCookie = function (cart) {
			if (!cart) return;

			// Set giftcard cart to expire in 60 minutes
			var expires = moment().add(60, 'minutes').format();

			$cookies.putObject('giftcard-cart', cart, {
				path: '/',
				expires: expires
			});
		};
	});
